import { SET_ALERT_STATE, SET_AlERTS_DATA } from "../Constants";
import { SET_NEW_AlERTS_DATA, SET_LAST_SCORE } from "../Constants";

export const setAlerts = (data) => ({
  type: SET_AlERTS_DATA,
  payload: data,
});

export const setNewAlerts = (data) => ({
  type: SET_NEW_AlERTS_DATA,
  payload: data,
});

export const setAlertState = () => ({
  type: SET_ALERT_STATE,
});

export const setLastScore = (data) => ({
  type: SET_LAST_SCORE,
  payload: data,
});
